import React from 'react';
import { InView } from 'react-intersection-observer';

import IconDeepResearchSmallI from '@components/Images/DeepResearch/IconDeepResearchSmallI';
import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import { useCurrentUser } from '@hooks/index';
import { useArticleSuggestedAiPrompts } from '@hooks/useArticleSuggestedAiPrompts';
import useEventTracking from '@hooks/useEventTracking';
import { deep_research_path } from '@routes';
import { ClickTarget, ImpressionElement, TrackingLocation, click, impression } from '@tracking';

import ExpandableFreePreview from './ExpandableFreePreview';
import Prompt from './Prompt';

const DeepResearch = () => {
  const { currentUser } = useCurrentUser();
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.DeepResearchMidArticlePromo,
  });

  const { isLoadingArticleSuggestedAiPrompt, articleSuggestedAiPrompt } =
    useArticleSuggestedAiPrompts();

  const handleLogoClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.DeepResearchLogo }));
  };

  return (
    <Track>
      <aside
        data-testid="mid-article-deep-research-unit"
        className="my-32 bg-[rgba(240,236,229,0.5)] p-16 sm:my-48 md:-ml-[60px] lg:-ml-[84px]"
      >
        <InView
          onChange={(inView) => {
            inView &&
              trackEvent(
                impression({ impressionElement: ImpressionElement.DeepResearchSinglePromptUnit })
              );
          }}
          triggerOnce
        >
          <div className="flex items-center justify-between">
            <h3 className="m-0 font-suisse-neue text-body-md text-grayscale-charcoal sm:text-subheadline-md">
              {currentUser?.is_pro_subscriber ? 'Try asking' : 'Upgrade to ask'} Deep Research to…
            </h3>
            <a href={deep_research_path()} onClickCapture={handleLogoClick}>
              <IconDeepResearchSmallI className="block w-28 sm:hidden" />
              <IconDeepResearchText className="hidden w-[188px] sm:block" />
            </a>
          </div>
          <div className="mt-20 lg:px-24">
            {isLoadingArticleSuggestedAiPrompt ? (
              <div className="text-center">
                <CustomSpinner size={10} color={CustomSpinnerColor.PrimaryMagenta} />
              </div>
            ) : (
              <>
                <Prompt prompt={articleSuggestedAiPrompt?.prompt} />
                <ExpandableFreePreview
                  freePreview={articleSuggestedAiPrompt?.freePreview}
                  prompt={articleSuggestedAiPrompt?.prompt}
                />
              </>
            )}
          </div>
        </InView>
      </aside>
    </Track>
  );
};

export default DeepResearch;
